"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EmployeeAvailabilitySchema = exports.AvailabilityRequestHistoryEntrySchema = exports.AvailabilityChangeRequestSchema = void 0;
const zod_1 = require("zod");
const WeekdaySchema = zod_1.z.number().int().min(0).max(6);
/**
 * An employee's proposed availability change, stored as a diff against the
 * APPROVED values on the row. It applies only when a manager approves it, so
 * `unavailableDays` / `unavailableDates` always mean "approved" for every reader.
 */
exports.AvailabilityChangeRequestSchema = zod_1.z.object({
    id: zod_1.z.string(),
    addDays: zod_1.z.array(WeekdaySchema).default([]), // recurring weekdays to block
    removeDays: zod_1.z.array(WeekdaySchema).default([]), // recurring weekdays to free
    addDates: zod_1.z.array(zod_1.z.string()).default([]), // "YYYY-MM-DD" to block
    removeDates: zod_1.z.array(zod_1.z.string()).default([]), // "YYYY-MM-DD" to free
    requestedAt: zod_1.z.number(),
    updatedAt: zod_1.z.number(),
});
exports.AvailabilityRequestHistoryEntrySchema = exports.AvailabilityChangeRequestSchema.extend({
    status: zod_1.z.enum(['approved', 'denied']),
    decidedAt: zod_1.z.number(),
    decidedBy: zod_1.z.string().optional(),
    decidedByName: zod_1.z.string().optional(),
    reason: zod_1.z.string().optional(),
});
exports.EmployeeAvailabilitySchema = zod_1.z.object({
    tenantId: zod_1.z.string(),
    employeeId: zod_1.z.string(),
    unavailableDays: zod_1.z.array(WeekdaySchema).default([]),
    unavailableDates: zod_1.z.array(zod_1.z.string()).default([]), // ["YYYY-MM-DD", ...] whole-day blocks
    updatedAt: zod_1.z.number(),
    /** Waiting for a manager — at most one per employee; later edits fold into it. */
    pendingRequest: exports.AvailabilityChangeRequestSchema.optional(),
    /** Decided requests, newest first (capped server-side). */
    requestHistory: zod_1.z.array(exports.AvailabilityRequestHistoryEntrySchema).optional(),
});
//# sourceMappingURL=availability.js.map